import { createQueryKeys } from '@/shared/data/create-query-keys';

// Arquivo leve: o manifesto e a porta usam as chaves sem puxar o fio para o JS inicial.
export const billingSettingKeys = createQueryKeys('billing-setting');
